import React from 'react'
import { l } from '@ds/index'
import cx from 'classnames'

import { PriceBreakdownList } from './PriceBreakdownList/PriceBreakdownList'
import { PriceRow } from './PriceRow'
import { formatMonthlyPrice, useCurrentPlanPriceBreakdown } from './useCurrentPlanPriceBreakdown'

import cm from './MigrationPlansView.module.css'

interface CurrentPlanBreakdownProps {
  className?: string
}

export const CurrentPlanBreakdown = ({ className }: CurrentPlanBreakdownProps) => {
  const { features, total } = useCurrentPlanPriceBreakdown()

  return (
    <div className={cx('d-flex flex-col bg-white', className)}>
      <h3 className="text-subheading-sm m-t-xxs">{l.translate('Current price breakdown:')}</h3>
      <PriceBreakdownList features={features} />
      <hr className={cx('m-y-sm', cm.divider)} />
      <PriceRow
        label={l.translate('Total cost')}
        value={l.getString(formatMonthlyPrice(total.amount, total.currency))}
        isBold
      />
      <div className="m-t-auto">
        <p className="text-body-sm text-secondary">
          {l.translate('If you don’t take any action, you’ll stay on your current plan.')}
        </p>
      </div>
    </div>
  )
}
